"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.translate = translate;

var translations = window._lang || {};

function translate(label) {
    return translations[label] || label;
}

var translationMixin = exports.translationMixin = {
    methods: {
        $t: translate
    }
};